<template>
  <div>
    <BreadCrumb class="bread" :breads="['广告管理','广告投放']"></BreadCrumb>
    <div class="wrap">
      <div class="header">
        <span class="nameFt">广告投放</span>
      </div>
      <div class="submit-form">
        <el-form :model="search" :inline="true" size="small" label-width="120px">
          <div class="submit-form__search">
            <el-form-item label="投放任务名称">
              <el-input v-model="search.name" size="small"></el-input>
            </el-form-item>
            <el-select v-model="search.status" placeholder="状态" size="small">
              <el-option v-for="(label, key) in options" :key="key" :label="label" :value="key"></el-option>
            </el-select>
          </div>
          <div class="submit-form__operate">
            <el-form-item>
              <el-button class="queryBtn" size="small" type="primary" @click="searchForm">查询</el-button>
              <el-button class="queryBtn" size="small" @click="reset">重置</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="operate-con">
        <el-button size="small" @click="openAdd">新增</el-button>
      </div>
      <div class="table-con">
        <el-table :data="tableList" stripe id="MainTables" style="width: 100%" v-loading="loading">
          <el-table-column label="序号" align="center" type="index" :index="indexMethod"></el-table-column>
          <el-table-column prop="name" label="投放任务名称" align="center"></el-table-column>
          <el-table-column prop="advertisement_count" label="投放广告数量" align="center"></el-table-column>
          <el-table-column prop="time_start" label="投放开始时间" align="center"></el-table-column>
          <el-table-column prop="time_end" label="投放结束时间" align="center"></el-table-column>
          <el-table-column prop="count" label="投放机器数量" align="center"></el-table-column>
          <el-table-column prop="desc" label="投放说明" align="center"></el-table-column>
          <el-table-column prop="status" label="状态" align="center">
            <div slot-scope="scope">{{options[scope.row.status]}}</div>
          </el-table-column>
          <el-table-column prop="start" label="操作" align="center" width="260">
            <template slot-scope="scope">
              <el-button size="small" @click="look(scope.row)">查看</el-button>
              <el-button
                size="small"
                type="primary"
                @click="examine(scope.row)"
                v-if="scope.row.status=='TO_BE_PUT'"
              >修改</el-button>
              <el-button
                size="small"
                type="primary"
                @click="putIn(scope.row)"
                v-if="scope.row.status=='TO_BE_PUT'"
              >投放</el-button>
              <el-button
                size="small"
                type="primary"
                @click="offline(scope.row)"
                v-if="scope.row.status=='PUTIN'"
              >下线</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="paginationWrap">
          <el-pagination
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :current-page="pageNum"
            :layout="pageLayout"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import apis from "@/config/apis";
import listMixin from "@/mixins/list";
import alert from "@/plugins/alert";
export default {
  name: "advertisingdelivery",
  mixins: [listMixin],
  data() {
    return {
      search: {},
      removeData: "",
      row_id: "",
      status: "",
      options: {
        TO_BE_PUT: "待投放",
        PUTIN: "投放中",
        PUT: "投放结束"
      }
    };
  },
  created() {
    this.search = Object.assign(this.search, this.$route.query);
    this.getData();
  },
  methods: {
    openAdd() {
      this.$router.push({
        path: "/index/addDelivery"
      });
    },
    examine(row) {
      this.$router.push({
        path: "/index/addDelivery",
        query: {
          id: row.id
        },
        params: this.$route.query
      });
    },
    modify(row) {
      this.$router.push({
        path: "/index/addDelivery",
        query: {
          id: row.id
        },
        params: this.$route.query
      });
    },
    look(row) {
      this.$router.push({
        path: "/index/addDelivery",
        query: {
          id: row.id,
          operate: "look"
        },
        params: this.$route.query
      });
    },
    //广告投放
    putIn(row) {
      const pid = row.id;
      alert.advertAlert().then(next => {
        this.$axios.get(apis.advert_to_terminal + "/" + pid).then(res => {
          if (res.data.code == 200) {
            this.$message({
              message: "投放成功",
              type: "success"
            });
            this.getData();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error"
            });
          }
        });
      });
    },
    //下线广告投放
    offline(row) {
      const pid = row.id;
      alert.offlineAlert().then(next => {
        this.$axios.get(apis.advert_down + "/" + pid).then(res => {
          if (res.data.code == 200) {
            this.$message({
              message: "下线成功",
              type: "success"
            });
            this.getData();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error"
            });
          }
        });
      });
    },
    searchForm() {
      this.search.page_index = 1;
      this.getData();
    },
    getData() {
      this.getTableData(apis.ad_serving_list, "get", this.search);
    },
    reset() {
      this.search = {};
      this.search.page_index = 1;
      this.searchForm();
    }
  },
  components: {
    BreadCrumb
  }
};
</script>

<style lang="scss" scoped>
/*弹窗*/

.el-icon-warning {
  color: #e6a23c;
  font-size: 60px;
}

.Main {
  text-align: center;
  .infoOne {
    font-size: 28px;
    line-height: normal;
  }
  .infoTwo {
    padding-top: 10px;
    font-size: 14px;
  }
}
</style>